import { SYMBOL_SET, LETTER_SET, DIGIT_SET } from '../constants'

/**
 * 使用 Web Crypto API 生成安全的随机索引
 * @param {number} max - 最大值（不包含）
 * @returns {number} 0 到 max-1 之间的随机整数
 */
export function secureRandomIndex(max) {
  if (max <= 0) {
    throw new Error('字符池不能为空')
  }
  const array = new Uint32Array(1)
  const limit = Math.floor(0x100000000 / max) * max
  let value
  do {
    window.crypto.getRandomValues(array)
    value = array[0]
  } while (value >= limit)
  return value % max
}

/**
 * 生成单个随机字符串
 * @param {Object} config - 配置对象
 * @param {number} config.length - 字符串长度
 * @param {boolean} config.includeLetters - 是否包含字母
 * @param {boolean} config.includeDigits - 是否包含数字
 * @param {boolean} config.includeSymbols - 是否包含特殊符号
 * @returns {string} 生成的随机字符串
 */
export function generateRandomString(config) {
  const { length, includeLetters, includeDigits, includeSymbols } = config
  let pool = ''
  if (includeLetters) pool += LETTER_SET
  if (includeDigits) pool += DIGIT_SET
  if (includeSymbols) pool += SYMBOL_SET

  if (!pool) {
    throw new Error('至少选择一种字符类型')
  }

  const characters = []
  for (let i = 0; i < length; i += 1) {
    const index = secureRandomIndex(pool.length)
    characters.push(pool.charAt(index))
  }
  return characters.join('')
}

/**
 * 生成多个随机字符串
 * @param {Object} config - 配置对象
 * @param {number} count - 生成数量，默认 10
 * @returns {string[]} 随机字符串数组
 */
export function generateRandomList(config, count = 10) {
  return Array.from({ length: count }, () => generateRandomString(config))
}
